import React, { useEffect, useState,useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid, OutlinedInput, Box, Chip, MenuItem, Select } from '@material-ui/core'
import { components, useServices, DataFlattener, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import TprApiUrls from '../../apiUrls/TprApiUrls'
import BillingConfigKeys from 'src/constants/locale/key/BillingConfig'
import ValidationSchema from './ValidationSchema'
import PartySection from './PartySection'

const {
    form: { field: { CngTextField, CngSelectField, CngCodeMasterAutocompleteField } },
    CngGridItem
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
    chargeCode: "",
    msgFunction: "",
    moduleName: "",
    submissionType: "",
    docType: "",
    status: "",
    chargeCodeDescription : "",
    chargeCodeParties: []
})

const FORMIK_PROPS = {
    initialValues: { ...DEFAULT_INITIAL_VALUES },
    makeValidationSchema: ValidationSchema
}

function Fields({ disabled, showNotification, shouldHideMap }) {
    const { securedSendRequest } = useServices();
    const { setValue, getValues , watch} = useFormContext();
    const { translate } = useTranslation([Namespace.UI_COMPONENT, Namespace.BILLING_CONFIG])
    const translatedTextsObject = makeTranslatedTextsObject()

    function makeTranslatedTextsObject() {
        let chargeCode = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.CHARGE_CODE
        )
        let msgFunction = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.MSG_FUNCTION
        )
        let moduleName = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.MODULE_NAME
        )
        let submissionType = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.SUBMISSION_TYPE
        )
        let docType = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.DOC_TYPE
        )
        let status = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.STATUS
        )
        let chargeCodeDescription = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.CHARGE_CODE_DESC
        )

        return {
            chargeCode,
            msgFunction,
            moduleName,
            submissionType,
            docType,
            status,
            chargeCodeDescription
        }
    }

    function fetchAllParty(setParty, securedSendRequest) {
        function onSuccess(response) {
            let content = response.data.content;
            let arr = [];

            content.forEach((e) => {
                let data = { text: e.name, value: e.id };
                arr.push(data);
            })
            // Set party list from registration
            setParty(arr)

            // Initialize selected values
            let existingArr = getValues("chargeCodeParties") || [];
            setSelectedParties(existingArr)

        }

        function onError(error) {
            console.log(error);
        }

        securedSendRequest.execute('POST', TprApiUrls.GET, {}, onSuccess, onError, () => { }, {}, null);
    }

    const [party, setParty] = useState([]);
    useEffect(() => { fetchAllParty(setParty, securedSendRequest) }, []);
 
    const chargeCodeParties = watch('chargeCodeParties')
    const [selectedParties, setSelectedParties] = useState([]);
    const [chargeCodePartiesDirty, setChargeCodePartiesDirty] = useState(false)
    
      const memoedPartySection = useMemo(
        () => <PartySection 
        chargeCodeParties={chargeCodeParties} 
        setChargeCodePartiesDirty={setChargeCodePartiesDirty} 
        />,
        [chargeCodeParties]
      )

    return (
        <Grid container spacing={3}>
            <CngGridItem sm={12} md={6}>
                <CngTextField name="chargeCode" required
                    label={translatedTextsObject.chargeCode}
                    inputProps={{ maxLength: 40 }}
                />
            </CngGridItem>
            <CngGridItem sm={12} md={6}>
                <CngTextField name="msgFunction"
                    label={translatedTextsObject.msgFunction}
                    inputProps={{ maxLength: 5 }}
                />
            </CngGridItem>
            <CngGridItem sm={12} md={6}>
                <CngCodeMasterAutocompleteField
                    required
                    name="moduleName"
                    label={translatedTextsObject.moduleName}
                    codeType='BILLING_MODULE'
                />
            </CngGridItem>
            <CngGridItem sm={12} md={6}>
                <CngCodeMasterAutocompleteField
                    name="submissionType"
                    label={translatedTextsObject.submissionType}
                    codeType='CHARGE_AS_CODE'
                />
            </CngGridItem>
            <CngGridItem sm={12} md={6}>
                <CngTextField name="docType" required
                    label={translatedTextsObject.docType}
                    inputProps={{ maxLength: 50 }}
                    onChange={(e) => {
                        setValue("docType", e.target.value.toUpperCase(), { shouldValidate: true })
                    }}
                />
            </CngGridItem>
            <CngGridItem sm={12} md={6}>
                <CngCodeMasterAutocompleteField
                    name="status"
                    label={translatedTextsObject.status}
                    codeType='BILLING_STATUS'
                />
            </CngGridItem>
            <CngGridItem sm={12} md={6}>
                <CngTextField name="chargeCodeDescription"
                    label={translatedTextsObject.chargeCodeDescription}
                    inputProps={{ maxLength: 100 }}
                />
            </CngGridItem>
             <Grid item xs={12}>
                    {memoedPartySection}
                  </Grid>
        </Grid>
    )
}

function toClientDataFormat(serverData) {
    let localData = DataFlattener.parse(serverData);
    return localData;
}

function toServerDataFormat(localData) {
    return DataFlattener.unflatten(localData);
}

const FormProperties = Object.freeze({
    formikProps: FORMIK_PROPS,
    Fields: Fields,
    toClientDataFormat: toClientDataFormat,
    toServerDataFormat: toServerDataFormat
})

export default FormProperties